<template>
  <section class="about-hero">
    <div class="banner">
      <div class="b-title">
        <div class="h1">{{ $t('aboutHero.title') }}</div>
        <div class="h2">{{ $t('aboutHero.subtitle') }}</div>
      </div>
    </div>

    <div class="bread-bar-wrapper">
      <div class="bread-bar section">
        <div class="left">
          <img class="item icon" src="@/static/image/about6.png" alt="icon" />
          <a href="/" class="item active">{{ $t('aboutHero.breadcrumbHome') }}</a>
          <span class="item">&gt;</span>
          <span class="item">{{ $t('aboutHero.breadcrumbCurrent') }}</span>
        </div>
        <div class="right">
          <a href="#qyjj" class="item">{{ $t('aboutHero.anchorIntro') }}</a>
          <a href="#ryzz" class="item">{{ $t('aboutHero.anchorHonor') }}</a>
          <a href="#qywh" class="item">{{ $t('aboutHero.anchorCulture') }}</a>
          <a href="#gltd" class="item">{{ $t('aboutHero.anchorTeam') }}</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutHero'
}
</script>

<style scoped lang="scss">
.about-hero {
  margin-top: 80px;
}
.banner {
  height: 390px;
  width: 100%;
  display: table;
  color: #fff;
  background: url('../../../../static/image/about-banner.png') center/cover no-repeat;
}
.b-title {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.h1 {
  font-size: 50px;
  font-weight: 800;
}
.h2 {
  margin-top: 8px;
  letter-spacing: 1px;
}
.bread-bar-wrapper {
  background: #fbfbfb;
}
.section {
  width: 1200px;
  margin: 0 auto;
}
.bread-bar {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left .item {
  margin-right: 10px;
  color: #666;
}
.left .active {
  color: #1c51a3;
  text-decoration: none;
}
.icon {
  width: 16px;
  vertical-align: middle;
}
.right .item {
  color: #666;
  text-decoration: none;
  margin-left: 30px;
}
.right .item:hover {
  color: #1c51a3;
}
</style>

